import { AggregatedReportWidget } from '../../../../../../../types';

import { useChartsData } from '../../hooks/useChartsData';

export const useBarChartWidgetData = (widget: AggregatedReportWidget) => {
  const data = useChartsData(widget);

  return data;
};
